import buildMode from '@nicolaudie-group/ng-ui-kit/helpers/buildMode'
import dev from '@nicolaudie-group/ng-ui-kit/helpers/dev'
import envFallback from '@nicolaudie-group/ng-ui-kit/helpers/envFallback'
import * as tokens from '@nicolaudie-group/ng-ui-kit/helpers/tokens'

import * as sdk from '@/helpers/sdk'
import { SDKTypes } from '@/helpers/sdk'

import {
  families,
  list,
  fixtureFamilies,
  fixtureTypes,
} from '@/models'

import pkgJson from '../package.json'

const assetsLocations = {
  icons: {
    channels: 'Images/Icons/profilebuilder/Channels',
    presets: 'Images/Icons/profilebuilder/Presets',
    gobos: 'Images/Icons/profilebuilder/gobos',
  },
}

const portalUrl = envFallback(
  'https://dev.nicolaudiegroup.com:8080/',
  'https://staging-cloud.nicolaudiegroup.com/',
  'https://cloud.nicolaudiegroup.com/',
)

const urlTemplates = {
  // Used to compute the link of a profile in the portal
  portalProfile: `${portalUrl}#/profiles/profile/%{uid}/infos`,
  // Used to compute the link of the owner of a profile in the admin portal
  adminUser: `${portalUrl}#/admin/users/user/%{uid}/account`,
  // Used to add query parameters to the profile download link
  profileDownload: '%{profileDownloadBaseUrl}?enableOptimization=%{enableOptimization}&_at=%{token}',
}

const shares = {
  public: '*',
  support: '@_support',
}

const groups = {
  admin: '_admin',
  SSLManager: '_sslManager',
}

const roles = {
  internal: 'internal',
}

const config = {
  version: pkgJson.version,
  titleBase: 'Profile Builder',
  titleSeparator: ' - ',
  env: envFallback(SDKTypes.Env.development, SDKTypes.Env.staging, SDKTypes.Env.production),
  /**
   * Interval at which the service worker should check for application updates, in seconds
   *
   * Currently set to 10 minutes
   */
  updatesCheckInterval: 60 * 10,
  clientUid: envFallback(
    '5af1d650-4a48-11e9-96eb-4570b38dfdfb-ac1d671d',
    '5af1d650-4a48-11e9-96eb-4570b38dfdfb-ac1d671d',
    '5fec9040-bccc-11e9-84d3-a7c478d08d86-2e25e79a',
  ),
  url: window.location.origin,
  dateFormat: 'YYYY-MM-DD HH:mm:ss Z',
  localDateFormat: 'dddd D MMM YYYY - HH:mm:ss',
  tzDateFormat: 'dddd D MMM YYYY - HH:mm:ss Z',
  shortDateFormat: 'ddd D MMM YY',
  assetsLocations,
  portalUrl,
  urlTemplates,
  shares,
  groups,
  roles,
  properties: {
    fixtureFamilies,
    fixtureTypes,
    modelsFamilies: families,
    modelsList: list,
    beamTypes: [
      { value: 0, label: 'Wash' },
      { value: 1, label: 'Spot' },
    ],
    lampTypes: [
      { value: 'led', label: 'LED' },
      { value: 'hmi', label: 'HMI' },
      { value: 'msd', label: 'MSD' },
      { value: 'hsd', label: 'HSD' },
    ],
    lampTempColors: [
      '#FF5900',
      '#FFF9FF',
      '#A1BFFF',
    ],
  },
}

/**
 * @type {import('@nicolaudie-group/lscore-sdk2-ts').SDKOptions}
 */
const sdkConfig = {
  env: config.env,
  clientVersion: config.version,
  withCredentials: true,
  authentication: () => ({
    type: SDKTypes.AuthenticationMethods.token,
    token: tokens.get(),
  }),
  log: {
    level: buildMode.dev ? SDKTypes.LogLevels.DEBUG : SDKTypes.LogLevels.INFO,
    selfXSSWarningEnabled: buildMode.prod,
  },
}

sdk.v2.configure(sdkConfig)
sdk.v3.configure(sdkConfig)

dev.configure({ exposeKey: 'pb' })

// For debugging purposes
dev.expose({
  sdk,
  config,
})

export default config
